export enum UserStatusEnum {
  Active = 0,
  Blocked = 1,
  New = 2,
  Updated = 3,
  Errors = 4
}
